import { useQuery } from "@tanstack/react-query";

import { importClient } from "./sdk/client";

export type OverviewItem = {
  id: string;
  name: string;
  provider_name: string;
  total_rows: number;
  success_count: number;
  error_count: number;
};

export type OverviewJobCounts = {
  success_count: number;
  error_count: number;
  successes: OverviewItem[];
  errors: OverviewItem[];
};

export type OverviewResourceGroup = {
  total: number;
  items: OverviewItem[];
};

export type OverviewResource = {
  since: string;
  extracts: OverviewJobCounts;
  loads: OverviewJobCounts;
  datasets: OverviewResourceGroup;
  streams: OverviewResourceGroup;
};

type GetOverviewResponse = {
  overview: OverviewResource;
};

const routes = {
  get: "/import/overview",
};

const keys = { all: ["import", "overview"] as const };

export function useImportOverview(days: number) {
  return useQuery({
    queryKey: [...keys.all, days],
    queryFn: () => importClient.get<GetOverviewResponse>(`${routes.get}?days=${days}`).then((data) => data.overview),
  });
}
